(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shava-ficha"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shava-guia')) {
    customElements.define('shava-guia', class extends HTMLElement {
      connectedCallback() {
        const ventana = this.querySelector('dialog');
        this.querySelector('.shava-guia__abrir').addEventListener('click', () => { this.marcar(); ventana.showModal(); });
        this.querySelector('.shava-guia__cerrar').addEventListener('click', () => ventana.close());
        // Un toque fuera de la ventana la cierra.
        ventana.addEventListener('click', (e) => { if (e.target === ventana) ventana.close(); });
      }
      // Marca la fila de la talla elegida en el selector de la ficha, si hay una.
      marcar() {
        const ficha = this.closest('.product-details, product-information, main') || document;
        const grupo = [...ficha.querySelectorAll('fieldset')].find((f) => /^\s*talla/i.test(f.querySelector('legend')?.textContent || ''));
        const talla = grupo?.querySelector('input:checked')?.value?.trim();
        this.querySelectorAll('.shava-guia__tabla tr').forEach((tr, i) => {
          tr.classList.toggle('sel', i > 0 && !!talla && tr.cells[0]?.textContent.trim() === talla);
        });
      }
    });
  }
  /* Visor de fotos de la ficha: clic en la foto y se abre a pantalla completa. La rueda
     acerca y aleja hacia el puntero (de 1× a 4×), arrastrando se recorre y el doble clic
     alterna entre 1× y 2,5×. En el celular: pellizcar, arrastrar, doble toque, y deslizar
     cambia de foto solo a 1×. Escucha en la captura de window para adelantarse al on:click
     de Horizon, que escucha en la captura de document y abriría su propio zoom. */
  if (!window.shavaVisor) {
    window.shavaVisor = true;
    const MIN = 1, MAX = 4, DOBLE = 2.5;
    const icono = (d) => `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
    let v = null, esc = null, img = null, fotos = [], i = 0, origen = null, galeria = null;
    let s = 1, tx = 0, ty = 0, base = { w: 0, h: 0 };
    const punteros = new Map();
    let gesto = null, ultimoToque = { t: 0, x: 0, y: 0 }, tipo = 'mouse', bajada = null;

    const limitar = (x) => Math.min(MAX, Math.max(MIN, x));
    // Tamaño de la foto a 1×: entera dentro de la pantalla, sin deformarla.
    const medir = () => {
      const r = esc.getBoundingClientRect();
      const nw = img.naturalWidth || fotos[i]?.w || 1, nh = img.naturalHeight || fotos[i]?.h || 1;
      const k = Math.min(r.width / nw, r.height / nh);
      base = { w: nw * k, h: nh * k };
      img.style.width = base.w + 'px'; img.style.height = base.h + 'px';
    };
    // La foto no se puede sacar de la pantalla: si es más chica va centrada; si es más
    // grande, sus bordes no se despegan de los de la pantalla.
    const pintar = (sinAnimar) => {
      const r = esc.getBoundingClientRect();
      const w = base.w * s, h = base.h * s;
      tx = w <= r.width ? (r.width - w) / 2 : Math.min(0, Math.max(r.width - w, tx));
      ty = h <= r.height ? (r.height - h) / 2 : Math.min(0, Math.max(r.height - h, ty));
      esc.classList.toggle('sin-animar', !!sinAnimar);
      esc.classList.toggle('ampliada', s > 1.01);
      img.style.transform = `translate(${tx}px, ${ty}px) scale(${s})`;
      v.querySelector('[data-accion="menos"]').disabled = s <= MIN + 0.001;
      v.querySelector('[data-accion="mas"]').disabled = s >= MAX - 0.001;
    };
    // El punto de la foto que está bajo (cx, cy) sigue ahí después del zoom.
    const zoomEn = (s2, cx, cy, sinAnimar) => {
      s2 = limitar(s2);
      const r = esc.getBoundingClientRect();
      const px = cx - r.left, py = cy - r.top;
      tx = px - (px - tx) * s2 / s; ty = py - (py - ty) * s2 / s;
      s = s2; pintar(sinAnimar);
    };
    const zoomCentro = (s2) => { const r = esc.getBoundingClientRect(); zoomEn(s2, r.left + r.width / 2, r.top + r.height / 2); };
    const alternar = (x, y) => zoomEn(s > 1.01 ? 1 : DOBLE, x, y);
    // Doble toque: dos toques cortos, juntos y en menos de 300 ms.
    const toque = (e) => {
      const ahora = performance.now();
      if (ahora - ultimoToque.t < 300 && Math.hypot(e.clientX - ultimoToque.x, e.clientY - ultimoToque.y) < 30) { alternar(e.clientX, e.clientY); ultimoToque.t = 0; }
      else ultimoToque = { t: ahora, x: e.clientX, y: e.clientY };
    };

    const ir = (n) => {
      if (!fotos.length) return;
      i = (n + fotos.length) % fotos.length;
      const f = fotos[i];
      img.alt = f.alt;
      s = 1; tx = 0; ty = 0;
      // Primero la que ya está en caché, que se ve al instante, y luego la grande.
      img.src = f.chica;
      medir(); pintar(true);
      if (f.grande && f.grande !== f.chica) {
        const g = new Image();
        g.onload = () => { f.chica = f.grande; if (fotos[i] === f) { img.src = f.grande; medir(); pintar(true); } };
        g.src = f.grande;
      }
    };

    const armar = () => {
      v = document.createElement('dialog');
      v.className = 'shava-visor';
      v.setAttribute('aria-label', 'Fotos del producto');
      v.innerHTML = `<div class="shava-visor__escena"><img class="shava-visor__foto" alt="" draggable="false"></div>
        <div class="shava-visor__botones">
          <button type="button" data-accion="menos" aria-label="Alejar">${icono('M5 12h14')}</button>
          <button type="button" data-accion="mas" aria-label="Acercar">${icono('M12 5v14M5 12h14')}</button>
          <button type="button" data-accion="cerrar" aria-label="Cerrar">${icono('M6 6l12 12M18 6L6 18')}</button>
        </div>
        <button type="button" class="shava-visor__flecha shava-visor__flecha--ant" data-accion="ant" aria-label="Foto anterior">${icono('M15 6l-6 6 6 6')}</button>
        <button type="button" class="shava-visor__flecha shava-visor__flecha--sig" data-accion="sig" aria-label="Foto siguiente">${icono('M9 6l6 6-6 6')}</button>`;
      document.body.append(v);
      esc = v.querySelector('.shava-visor__escena');
      img = v.querySelector('.shava-visor__foto');

      v.addEventListener('click', (e) => {
        const a = e.target.closest('[data-accion]')?.dataset.accion;
        if (a === 'cerrar') v.close();
        else if (a === 'mas') zoomCentro(s * 1.5);
        else if (a === 'menos') zoomCentro(s / 1.5);
        else if (a) ir(i + (a === 'sig' ? 1 : -1));
      });
      // La rueda nunca llega a la página de fondo.
      v.addEventListener('wheel', (e) => {
        e.preventDefault();
        if (e.target !== esc) return;
        const d = e.deltaMode === 1 ? e.deltaY * 33 : e.deltaY;
        zoomEn(s * Math.pow(1.0018, -Math.max(-300, Math.min(300, d))), e.clientX, e.clientY);
      }, { passive: false });
      v.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') ir(i + 1);
        else if (e.key === 'ArrowLeft') ir(i - 1);
        else if (e.key === '+' || e.key === '=') zoomCentro(s * 1.5);
        else if (e.key === '-' || e.key === '_') zoomCentro(s / 1.5);
        else return;
        e.preventDefault();
      });
      v.addEventListener('close', () => {
        punteros.clear(); gesto = null;
        // La foto que quedó en el visor pasa a ser la del carrusel, y el foco vuelve a ella.
        // Un cuadro después: con el visor aún en la capa de arriba el carrusel no se movía.
        const slide = fotos[i]?.slide;
        const show = galeria?.querySelector('slideshow-component');
        requestAnimationFrame(() => {
          if (show && slide && typeof show.select === 'function') {
            const n = [...show.querySelectorAll('slideshow-slides > slideshow-slide')].indexOf(slide);
            if (n >= 0 && n !== show.current) show.select(n, undefined, { animate: false });
          }
          // La foto del carrusel no es enfocable: se le deja recibir el foco sin entrar al Tab.
          const foco = slide?.querySelector('button') || slide || origen;
          if (foco && !foco.matches('button, [tabindex]')) foco.tabIndex = -1;
          foco?.focus?.({ preventScroll: true });
        });
      });

      esc.addEventListener('dblclick', (e) => { if (tipo !== 'touch') alternar(e.clientX, e.clientY); });
      esc.addEventListener('pointerdown', (e) => {
        tipo = e.pointerType;
        esc.setPointerCapture(e.pointerId);
        punteros.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (punteros.size === 2) {
          const [a, b] = [...punteros.values()];
          gesto = { tipo: 'pellizco', d: Math.hypot(a.x - b.x, a.y - b.y), s, tx, ty, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 };
        } else if (punteros.size === 1) {
          gesto = { tipo: s > 1.01 ? 'arrastre' : 'deslizar', x: e.clientX, y: e.clientY, tx, ty };
        }
        esc.classList.add('arrastrando');
      });
      esc.addEventListener('pointermove', (e) => {
        if (!punteros.has(e.pointerId) || !gesto) return;
        punteros.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (gesto.tipo === 'pellizco' && punteros.size === 2) {
          const [a, b] = [...punteros.values()];
          const cx = (a.x + b.x) / 2, cy = (a.y + b.y) / 2;
          const s2 = limitar(gesto.s * Math.hypot(a.x - b.x, a.y - b.y) / (gesto.d || 1));
          const r = esc.getBoundingClientRect();
          tx = cx - r.left - (gesto.cx - r.left - gesto.tx) * s2 / gesto.s;
          ty = cy - r.top - (gesto.cy - r.top - gesto.ty) * s2 / gesto.s;
          s = s2; pintar(true);
        } else if (gesto.tipo === 'arrastre') {
          tx = gesto.tx + e.clientX - gesto.x; ty = gesto.ty + e.clientY - gesto.y; pintar(true);
        }
      });
      const soltar = (e) => {
        if (!punteros.has(e.pointerId)) return;
        punteros.delete(e.pointerId);
        if (gesto && gesto.tipo !== 'pellizco' && punteros.size === 0) {
          const dx = e.clientX - gesto.x, dy = e.clientY - gesto.y;
          if (gesto.tipo === 'deslizar' && e.pointerType !== 'mouse' && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) ir(i + (dx < 0 ? 1 : -1));
          else if (e.pointerType === 'touch' && Math.hypot(dx, dy) < 10) toque(e);
        }
        if (punteros.size === 1) {
          // Queda un dedo tras pellizcar: sigue como arrastre desde donde está.
          const [p] = [...punteros.values()];
          gesto = { tipo: s > 1.01 ? 'arrastre' : 'nada', x: p.x, y: p.y, tx, ty };
        } else if (punteros.size === 0) {
          gesto = null;
          esc.classList.remove('arrastrando');
          if (s < 1.01) s = 1;
          pintar();
        }
      };
      esc.addEventListener('pointerup', soltar);
      esc.addEventListener('pointercancel', soltar);
      addEventListener('resize', () => { if (v.open) { medir(); pintar(true); } });
    };

    const abrir = (gal, slide, quien) => {
      const slides = [...gal.querySelectorAll('slideshow-slides > slideshow-slide.product-media-container--image')];
      const lista = slides.map((sl) => {
        const im = sl.querySelector('img.product-media__image');
        return { slide: sl, alt: im?.alt || '', chica: im?.currentSrc || im?.src, grande: im?.getAttribute('data_max_resolution'), w: +im?.getAttribute('width') || 0, h: +im?.getAttribute('height') || 0 };
      }).filter((f) => f.chica);
      if (!lista.length) return false;
      if (!v) armar();
      galeria = gal; origen = quien; fotos = lista;
      v.querySelectorAll('.shava-visor__flecha').forEach((b) => { b.hidden = fotos.length < 2; });
      v.showModal();
      ir(Math.max(0, fotos.findIndex((f) => f.slide === slide)));
      v.querySelector('[data-accion="cerrar"]').focus({ preventScroll: true });
      return true;
    };

    // Un clic que viene de arrastrar el carrusel con el mouse no abre el visor.
    addEventListener('pointerdown', (e) => { bajada = { x: e.clientX, y: e.clientY }; }, true);
    addEventListener('click', (e) => {
      const slide = e.target instanceof Element ? e.target.closest('slideshow-slide.product-media-container--image') : null;
      if (!slide || slide.closest('dialog, .quick-add-modal')) return;
      const gal = slide.closest('.product-information media-gallery');
      if (!gal) return;
      if (bajada && e.detail > 0 && Math.hypot(e.clientX - bajada.x, e.clientY - bajada.y) > 8) return;
      if (abrir(gal, slide, e.target.closest('button') || slide)) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
